import { accessTypeEnum } from './../../lib/enum';

const addAccessRight = [
  accessTypeEnum.admin,
  accessTypeEnum.handlingVehicleWashingTypeToGroupsMaps
];

export default addAccessRight;
